import { gql } from '@apollo/client';

export const UPDATE_FINAL_EXAM = gql`
  mutation UpdateFinalExam($updateFinalExamInput: UpdateFinalExamInput!) {
    updateFinalExam(updateFinalExamInput: $updateFinalExamInput) {
      questionId
      question {
        id
        prompt
        options {
          desc
          isAnswer
        }
        explanation
        tag
      }
      selectedOption {
        desc
        isAnswer
      }
    }
  }
`;
